import type { CSSProperties } from 'react';
import type { IProgressBarProps } from './ProgressBar.interface';
import styles from './ProgressBar.module.css';

export enum StyleElem {
    Container = 'Container',
    Bar = 'Bar',
    Text = 'Text',
}

const DEFAULT_PROPS: Required<IProgressBarProps> = {
    progress: 0,
    textColor: '#FFFFFF',
    barColor: '#3bb1dc',
    borderRadius: 0,
    style: {},
    className: '',
    description: '',
};

const DEFAULT_STYLES: Record<StyleElem, CSSProperties> = {
    [StyleElem.Container]: {},
    [StyleElem.Bar]: {},
    [StyleElem.Text]: {},
};

/* Cap #progress to >0 & <1, multiply up to 0->100 range, round number, then append '%' */
export function progressToText(progress: number) {
    return `${Math.round(Math.min(Math.max(progress, 0), 1) * 100)}%`;
}

const PROPS_APPLICATOR: Record<StyleElem, (props: IProgressBarProps) => CSSProperties> = {
    [StyleElem.Container]: (props: IProgressBarProps) => ({
        borderRadius: props.borderRadius ?? DEFAULT_PROPS.borderRadius,
    }),
    [StyleElem.Bar]: (props: IProgressBarProps) => ({
        width: progressToText(props.progress),
        backgroundColor: props.barColor ?? DEFAULT_PROPS.barColor,
        borderRadius: props.borderRadius ?? DEFAULT_PROPS.borderRadius,
    }),
    [StyleElem.Text]: (props: IProgressBarProps) => ({
        color: props.textColor ?? DEFAULT_PROPS.textColor,
    }),
};

export function classNameForElement(element: StyleElem, props: IProgressBarProps): string {
    const name = element.toString();
    const classLoad = styles[name];
    return classLoad || '';
}

export function styleForElement(
    element: StyleElem,
    props: IProgressBarProps,
    overrides?: CSSProperties,
): CSSProperties {
    const style = { ...DEFAULT_STYLES[element], ...PROPS_APPLICATOR[element](props), ...overrides };

    return style;
}
